import { render, staticRenderFns } from "./SendCouponAllShops.vue?vue&type=template&id=032604d4&scoped=true&"
import script from "./SendCouponAllShops.vue?vue&type=script&lang=js&"
export * from "./SendCouponAllShops.vue?vue&type=script&lang=js&"
import style0 from "./SendCouponAllShops.vue?vue&type=style&index=0&id=032604d4&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "032604d4",
  null
  
)

export default component.exports